// Copy that only exists in the prototype files of the Us screens (not in shared/src/content). Each line names its
// source; lines marked "app" are new for states the prototype does not show (locked chest, coming soon, ...).
import { WEEK_CHEST_MIN_LIT } from '@shared/rules';

export const US = {
  // QU1_Us
  levelNote: 'Every card adds points. Each level opens the next stop: a new chapter, a new look for the place, a keepsake or a new sound.',
  allOpenHead: 'ALL STOPS OPEN',
  keepGoing: 'Keep going. Every card still counts.',
  allLooks: 'All 7 looks open',
  weekReady: 'Sunday recap is ready',
  weekFirst: 'Your first recap comes on Sunday',
  nextHead: 'NEXT STOP', // app: the next stop has no content yet, so no level is promised
  // QU2_Story
  storyEnd: 'That is the whole story, for now.',
  // QU3_Week
  question: 'What got a little easier this week?',
  holdHint: 'Hold to talk. One sentence is plenty.',
  chest: 'Week chest',
  chestReady: (lit: number) => `You lit ${lit} of 7 days. That earns this week's chest.`,
  chestLocked: (lit: number) => `You lit ${lit} of 7 days. The chest needs ${WEEK_CHEST_MIN_LIT} lit days.`, // app (server message)
  notReady: 'The week recap is ready on Sunday evening.', // app (server message, week_not_ready)
  // QU4_Collection
  keepNote: 'New keepsakes come with levels. Each one has a spot on your side of the place.',
  allCards: 'That is every card so far.',
};
